<template>
  <div class="row my-4">
    <div class="col-6" v-if="anterior">
      <router-link
        tabindex="9"
        :to="{ name: anterior }"
        class="btn btn-raised btn-upvehu-blanco mx-2">
        <i class="fa fa-chevron-left"></i> {{ $t('anterior') }}
      </router-link>
    </div>
    <div class="col-6" v-if="siguiente && siguienteIf">
      <router-link
        tabindex="9"
        :to="{ name: siguiente }"
        class="btn btn-raised btn-upvehu-negro float-right mx-2">
        {{ $t('siguiente') }} <i class="fa fa-chevron-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    anterior: String,
    siguiente: String,
    siguienteIf: Boolean
  },
  methods: {
  },
  computed: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
